import React, { useCallback, useEffect, useMemo, useState } from "react";
import Icon, { Icons } from "@/components/Joyspace/Icon";
import { Popover } from "antd";
import IconFont from "@/components/icon";
import "./index.less";
import { isBjme } from "@/utils";
import { ContextMenuMode } from "@/components/Joyspace/types";
import events from "@/components/Joyspace/context/events";

interface IProps {
  contextMenuMode?: ContextMenuMode;
  isShortcut: boolean;
  callback: Function;
  popoverDisabled: boolean; // （离线状态&&数据库里没有该数据）就为true否则为false
  offlineDisabled: boolean; // 离线为true否则为false
  isFolder: boolean;
}

export default function ShortcutPopover(props: IProps) {
  const {
    isShortcut,
    callback,
    popoverDisabled = false,
    isFolder = true,
    offlineDisabled = false,
    contextMenuMode = ContextMenuMode.Click
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const handleVisibleChange = useCallback((_visible = false) => {
    setVisible(_visible);
  }, []);
  useEffect(() => {
    events.on("handlePopoverVisibleChange", handleVisibleChange);
    return () => {
      events.off("handlePopoverVisibleChange", handleVisibleChange);
    };
  }, [handleVisibleChange]);
  const className = useMemo(() => {
    let className = "joyspace-trigger-icon";
    if (visible) {
      className += " joyspace-trigger-actions";
    }
    if (popoverDisabled) {
      className += " joyspace-trigger-icon_disabled";
    }
    return className;
  }, [visible, popoverDisabled]);
  const content = useMemo(() => {
    return (
      <ul
        className={
          offlineDisabled
            ? "joyspace-operate-lists shortcut-operate-ul-disabled"
            : "joyspace-operate-lists"
        }
        onContextMenu={(event) => {
          event.stopPropagation();
        }}
      >
        {!isFolder && (
          <li
            onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              !popoverDisabled && callback("edit");
              events.emit("hideContextMenus");
            }}
          >
            <IconFont type="iconpc_yundocument_open" className="joyspace-shortcut-operate-icon" />
            打开
          </li>
        )}
        <li
          log-analysis-data="xtbg_jzb_joyspace_home_1676548210761|34"
          onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            !offlineDisabled && callback("shortcut");
            events.emit("hideContextMenus");
          }}
        >
          <Icon
            type={isBjme() ? "iconpc_yundoc_retop" : "iconjs_ic_Recycle"}
            className="joyspace-shortcut-operate-icon"
          />
          取消置顶
        </li>
      </ul>
    );
  }, [callback, isFolder, offlineDisabled, popoverDisabled]);
  if (contextMenuMode === ContextMenuMode.ContextMenu) {
    return <div className="shortcut-popover">{content}</div>;
  }
  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      overlayClassName="shortcut-popover"
      onVisibleChange={handleVisibleChange}
      visible={visible}
      content={content}
    >
      <a
        href="#"
        type="default"
        onClick={(e) => {
          e.stopPropagation();
          events.emit("hideContextMenus");
        }}
        onContextMenu={(event) => {
          event.stopPropagation();
        }}
      >
        <span className={className}>{Icons.trigger}</span>
      </a>
    </Popover>
  );
}
